module.exports = __webpack_public_path__ + "media/images/features/modification/arrow-question-771ac095f9470b1b91b7ee6f7e65174a.svg";